import * as React from 'react';
import { Table, Button } from 'react-bootstrap';
import { IInvoiceJournal } from '../Entities';
import { Translate } from '../../../shared/LanguageService';
import DateTimeView from '../../localDate/DateTimeView';

interface IProps {
    list: IInvoiceJournal[];
    foreign: boolean;
    view: (id: number) => void;
}

const InvoiceJournalList = (props: IProps) => {
    return (
        <Table hover responsive>
            <thead>
                <tr>
                    <th>{Translate('invoice-journal/list/table-header/id')}</th>
                    <th>{Translate('invoice-journal/list/table-header/created-date')}</th>
                    <th>{Translate('invoice-journal/list/table-header/number-of-invoices')}</th>
                    <th>{Translate('invoice-journal/list/table-header/debit')}</th>
                    <th>
                        {!props.foreign
                            ? Translate('invoice-journal/list/table-header/credit')
                            : Translate('invoice-journal/list/table-header/3048/credit')}
                    </th>
                    {!props.foreign && (
                        <th>{Translate('invoice-journal/list/table-header/vat')}</th>
                    )}
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.list.map((x: IInvoiceJournal, index: number) => (
                    <tr key={index}>
                        <td>{x.id}</td>
                        <td>
                            <DateTimeView dateTime={x.createdDate} format="LL" />
                        </td>
                        <td>{x.numberOfInvoices}</td>
                        <td>{x.debit}</td>
                        <td>{x.credit}</td>
                        {!props.foreign && <td>{x.vat}</td>}
                        <td>
                            <Button
                                className="pull-right"
                                onClick={() => props.view(x.id)}
                                bsSize="sm"
                                bsStyle="info"
                            >
                                <i className="material-icons">pageview </i>
                                {Translate('invoice-journal/list/table/view/button')}
                            </Button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default InvoiceJournalList;
